import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useUserContext from 'Context/UserContext';
import { pickImplementation } from 'Helpers/Affordances';
import fr from 'facet-rest';
import ShareSchedulerLink from 'Components/UI/ShareSchedulerLink';

const styles = theme => ({
  root: {
    padding: theme.spacing(4),
  },
  projectedMeetingList: {
    marginTop: theme.spacing(2.5),
  },
});

const ProjectedMeetingList = ({
  className,
  classes,
}) => {
  const { agentResource } = useUserContext();
  const ShareSchedulerLinkComponent = pickImplementation(agentResource, {
    [fr.relationships.default.name]: <ShareSchedulerLink />,
  });
  return (
    <div
      className={classNames(classes.root, className)}
    >
      {ShareSchedulerLinkComponent}
    </div>
  );
};

ProjectedMeetingList.defaultProps = {
  className: '',
};

ProjectedMeetingList.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ProjectedMeetingList);
